import { useMutation, useQueryClient } from "@tanstack/react-query";
import { sendMRDCLink } from "@/api/v1-jwt/mrdc/mrdc";

export const useSendMRDCLink = () => {
  const query = useQueryClient();

  return useMutation({
    mutationFn: sendMRDCLink,
    onSuccess: () => {
      query.invalidateQueries(["mrdc"]);
    },
  });
};
